<template>
  <v-container fluid class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <TradesCard class="trades-card-wrapper" />
      </v-col>
    </v-row>
  
    <v-row no-gutters>
      <v-col cols="12">
        <Optionchain class="optionchain-wrapper" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Optionchain from "@/components/strategy/Optionchain.vue";
import TradesCard from "@/components/strategy/TradesCard.vue";

export default {
  name: "StrategyPage",
  components: { Optionchain, TradesCard },
};
</script>

<style scoped>
.optionchain-wrapper,
.trades-card-wrapper {
  max-width: 1400px;
  margin: 0 auto;
}

.custom-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #666;
  border-radius: 8px;
  background: #cbe1f3;
  color: #000;
  height: 100%;
  min-height: 200px;
  resize: none;
  font-family: monospace;
  font-size: 0.75rem;
}
</style>